import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';

@Injectable()
export class EncryptionKeyService {

  private EncryptionKey: string;

  constructor(private afs: AngularFirestore) {
    const y = afs.collection('assets').doc('EncryptionKey');
    y.snapshotChanges().forEach(d => {
      if (d.payload.exists) {
        this.EncryptionKey = <string>d.payload.get('key');
      }
    });
  }

  getEncryptionKey(): string {
    return this.EncryptionKey;
  }

}



// WEBPACK FOOTER //
// ./src/app/encryption-key.service.ts